import React from "react";
import { connect } from "react-redux";
import { ImageManagerContext } from "./ImageManager";

class EditableImage extends React.Component {
  constructor(props) {
    super(props);
    this.image = null;
    this.state = EditableImage.getDerivedStateFromProps(props, null);
  }

  componentDidMount() {
    this.preload();
  }

  componentDidUpdate(prevProps, prevState) {
    this.preload();
  }

  componentWillUnmount() {
    if (this.image) this.image.onload = null;
  }

  preload() {
    let url = this.getUrl();
    if (!url || this.state.loaded === url) return;
    this.image = new Image();
    this.image.onload = () => this.imageLoaded(url);
    this.image.src = url;
  }

  onSelect(image) {
    // console.log('onSelect', image)
    if (this.props.onInput) {
      this.props.onInput(image);
    } else {
      this.props.object[this.props.field || "image"] = image;
    }
    this.setState({
      image,
      loaded: "",
    });
    this.image = null;
  }

  static getDerivedStateFromProps(props, state) {
    let image;
    if ("image" in props) image = props.image;
    else image = props.object[props.field || "image"];
    if (!state || image !== state.image) {
      return {
        image,
        loaded: "",
      };
    }
    return null;
  }

  getUrl() {
    if (this.state.image) {
      let image = this.props.images.find((x) => x.name === this.state.image);
      return (image || {}).url || "";
    } else return "";
  }

  imageLoaded(src) {
    let url = this.getUrl();
    if (url && url === src) {
      this.setState({ loaded: src });
    }
  }

  render() {
    return (
      <ImageManagerContext.Consumer>
        {(context) => {
          let url = this.getUrl();
          if (!url || this.state.loaded !== url) url = "/images/greyImage.jpg";

          let select = () => {};
          if (this.props.editable)
            select = () => context.request((image) => this.onSelect(image));

          return this.props.children({
            url,
            select,
            editable: this.props.editable,
          });
        }}
      </ImageManagerContext.Consumer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    images: state.images,
  };
};

export default connect(mapStateToProps)(EditableImage);
